import React, { useState, useEffect } from "react";
import { DashboardTable } from "../../components";
import {
  getDashboardPerMealCategory,
  getDashboardPerMealCategoryPerPatient,
} from "../../services";

// TODO: Add department selectbox
const PerMealCategory = (props) => {
  const { locationId, startDate, endDate, departmentId, filter } = props;
  const [data, setData] = useState();
  // const [filter, setFilter] = useState(0);
  const [dashboardType, setDashboardType] = useState(0);
  const [totalButtonClass, setTotalButtonClass] = useState("dashboard__buttons__button button__active")
  const [averageButtonClass, setAverageButtonClass] = useState("dashboard__buttons__button")
  const [averagePerPatientButtonClass, setAveragePerPatientButtonClass] = useState("dashboard__buttons__button")

  useEffect(() => {
    if (dashboardType == 2) {
      getDashboardPerMealCategoryPerPatient(
        locationId,
        startDate,
        endDate,
        departmentId,
        filter
      ).then((res) => {
        setData(res);
      });
    } else {
      getDashboardPerMealCategory(locationId, startDate, endDate, departmentId, filter).then(
        (res) => {
          setData(res);
        }
      );
    }
  }, [locationId, startDate, endDate, departmentId, dashboardType, filter]);

  return (
    <div className="dashboard__container">
      <div className="dashboard__buttons">
        <button
          class={totalButtonClass}
          onClick={() => {
            setDashboardType(0);
            setTotalButtonClass("dashboard__buttons__button button__active")
            setAverageButtonClass("dashboard__buttons__button")
            setAveragePerPatientButtonClass("dashboard__buttons__button")
          }}
        >
          Totaal per dag
        </button>
        <button
          class={averageButtonClass}
          onClick={() => {
            setDashboardType(1);
            setTotalButtonClass("dashboard__buttons__button")
            setAverageButtonClass("dashboard__buttons__button button__active")
            setAveragePerPatientButtonClass("dashboard__buttons__button")
          }}
        >
          Gemiddelde weekdag
        </button>
        <button
          class={averagePerPatientButtonClass}
          onClick={() => {
            setDashboardType(2);
            setTotalButtonClass("dashboard__buttons__button")
            setAverageButtonClass("dashboard__buttons__button")
            setAveragePerPatientButtonClass("dashboard__buttons__button button__active")
          }}
        >
          Gemiddelde weekdag per bewoner
        </button>
      </div>
      <div className="dashboard__container__table">
        {dashboardType == 0 && (
          <TotalPerCategory
            data={data}
            startDate={startDate}
            endDate={endDate}
            filter={filter}
          />
        )}
        {dashboardType == 1 && (
          <AveragePerWeekday
            data={data}
            startDate={startDate}
            endDate={endDate}
            filter={filter}
          />
        )}
        {dashboardType == 2 && (
          <AveragePerWeekday
            data={data}
            startDate={startDate}
            endDate={endDate}
            filter={filter}
          />
        )}
      </div>
    </div>
  );
};

// Function to render the total waste per meal category per day
const TotalPerCategory = (props) => {
  const { data, startDate, endDate, filter } = props;
  let sd = new Date(startDate.getTime());
  const head = [];
  var weekday = new Array(7);
  weekday[0] = "Zo";
  weekday[1] = "Ma";
  weekday[2] = "Di";
  weekday[3] = "Wo";
  weekday[4] = "Do";
  weekday[5] = "Vr";
  weekday[6] = "Za";
  head.push("Maaltijdcomponent");
  for (sd; sd <= endDate; sd.setDate(sd.getDate() + 1)) {
    const date = new Date(sd);
    head.push(
      `${weekday[date.getDay()]} ${date.getDate()}/${date.getMonth() + 1}`
    );
  }
  head.push("Totaal");
  // Totalrow
  const totalRow = [];
  if(data) {
    data.data.forEach((val, index) => {
      val.forEach((value, index) => {
        if (index > 0) {
          if(totalRow[index]) totalRow[index] += value;
          else totalRow[index] = value;
        }
      })
    })
    totalRow[0] = 'Totaal';
    data.data.push(totalRow)
  }

  return <div>{data && <DashboardTable filter={filter} data={data.data} head={head} />}</div>;
};

// Function to render the average per weekday during selected period
const AveragePerWeekday = (props) => {
  const { data, startDate, filter } = props;
  const totalRow = [];
  let sd = new Date(startDate.getTime());
  let body = [];
  let head = [
    "Maaltijd component",
    "Maandag",
    "Dinsdag",
    "Woensdag",
    "Donderdag",
    "Vrijdag",
    "Zaterdag",
    "Zondag",
    "Totaal"
  ];
  if (data) {
    // Loop through data every row is a meal category with its measurements per day
    data.data.map((row, i) => {
      let tableRow = [];
      let dayofweek = sd.getDay();
      // Initialize array to calculate the average for a week day foreach meal category
      var averageWeekDay = new Array(7);
      averageWeekDay[0] = { value: 0, times: 0 }; // Monday
      averageWeekDay[1] = { value: 0, times: 0 }; // Tuesday
      averageWeekDay[2] = { value: 0, times: 0 }; // Wednesday
      averageWeekDay[3] = { value: 0, times: 0 }; // Thursday
      averageWeekDay[4] = { value: 0, times: 0 }; // Friday
      averageWeekDay[5] = { value: 0, times: 0 }; // Saturday
      averageWeekDay[6] = { value: 0, times: 0 }; // Sunday
      row.map((value, index) => {
        if (index == (row.length - 1)) {

        }
        else if (typeof value == "number") {
          // Sunday correction
          if (dayofweek !== 0) {
            averageWeekDay[dayofweek - 1].value += value;
            averageWeekDay[dayofweek - 1].times += 1;
          } else {
            averageWeekDay[6].value += value;
            averageWeekDay[6].times += 1;
          }
          if (dayofweek === 6) dayofweek = 0;
          else dayofweek++;
        }
      });
      // Push first row with meal category
      tableRow.push(row[0]);
      // Loop through all the average weekday and push into a row for dashboardtable
      averageWeekDay.map((obj, i) => {
        const average = obj.value / obj.times;
        const round = Math.round((average + Number.EPSILON) * 100) / 100;
        if (obj.value !== 0) tableRow.push(round);
        else tableRow.push(0);
      });
      // Append body with tablerow
      tableRow.push(row[row.length - 1])
      // Totalrow
      tableRow.forEach((val, i) => {
        if(i !== 0) {
          if(totalRow[i]) totalRow[i] += val;
          else totalRow[i] = val;
        }
      })
      totalRow[0] = 'Totaal'
      body.push(tableRow);
    });
    body.push(totalRow);
  }

  if (body) {
    return <DashboardTable filter={filter} data={body} head={head} />;
  }

  return <div></div>;
};

export default PerMealCategory;
